import { render, staticRenderFns } from "./FabricOutList.vue?vue&type=template&id=3485c8d6&"
import script from "./FabricOutList.vue?vue&type=script&lang=js&"
export * from "./FabricOutList.vue?vue&type=script&lang=js&"
import style0 from "./FabricOutList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports